<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="centerDialogVisible"
      :append-to-body="true"
      :width="width"
      :before-close="handleClose"
    >
      <slot />
      <span v-if="footer" slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" @click="handleConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  // 组件名称
  name: 'Dialog',
  // 过滤器
  filters: {
  },
  // 组件
  components: {
  },
  // props类型
  props: {
    // 是否隐藏弹窗
    centerDialogVisible: {
      type: Boolean,
      default: false
    },
    // 标题
    title: {
      type: String,
      default: '提示'
    },
    footer: {
      type: Boolean,
      default: true
    },
    screenWidth: {
      type: String,
      default: '30%'
    }
  },
  // 数据
  data() {
    return {
      width: '30%'
    }
  },
  // 计算属性
  computed: {
  },
  // 计算属性监听
  watch: {
  },
  // 创建时
  created() {
    this.width = this.screenWidth
  },
  // 挂载完毕
  mounted() {
  },
  // 方法
  methods: {
    handleClose() {
      this.handleCancel()
    },
    handleCancel() {
      this.$emit('handleCancel')
    },
    handleConfirm() {
      this.$emit('handleConfirm')
    }
  }
}
</script>

<style lang='less' scoped>

</style>
